export const API_URI = 'https://api.cinecelebrate.com/api';
// export const API_URI = 'http://localhost:8080/api';
